import React from 'react'
import PreBuiltTaskDetailView from './components/PreBuiltTaskDetailView'

export default function PreBuiltTaskDetail() {
  return <PreBuiltTaskDetailView />
}
